export default "__VITE_ASSET__3e5d3b4e__"